import { WebSocketUrl, FocusBaseUrl, JoiApiUrl } from '../../Utils/Utils';

export const READY = {
  CONNECTING: WebSocket.CONNECTING,
  OPEN: WebSocket.OPEN,
  CLOSING: WebSocket.CLOSING,
  CLOSED: WebSocket.CLOSED,
} as const;

export const WS_URL = WebSocketUrl() || '';
export const FOCUS_BASE_URL = FocusBaseUrl() || '';
export const JOI_API_URL = JoiApiUrl() || '';

export const MAX_CHAT_INPUT_CHARS = 50000;

// Must match CHAT_HISTORY_PAGE_SIZE on the backend (currently 10). A page
// shorter than this means the oldest messages have been reached.
export const HISTORY_PAGE_SIZE = 10;

// File upload limits — checked before uploading, so they must match what
// the backend accepts. The upload panel's file picker and hint, the
// validation messages and the Help Center all read these: change them here.
// The file limit is per upload ("at once"), not per chat.
export const UPLOAD_ACCEPTED_FORMATS: readonly string[] = ['pdf', 'docx', 'xlsx', 'csv', 'pptx', 'txt', 'jpg', 'jpeg', 'png'];
export const UPLOAD_MAX_FILES = 10;
export const UPLOAD_MAX_MB = 25;
export const UPLOAD_MAX_BYTES = UPLOAD_MAX_MB * 1024 * 1024;